import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import create from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import axios from 'axios';
import { FOCUS_PEOPLE_STATUS } from '../constants/userConstants';
import { useAuthStore } from './authStore';
import { mixpanelSetUserProperty } from '../helpers/mixPanelHelper';
import { getViewerCapabilities } from '@helpers/capabilityHelpers';
var initialState = {
    manager: null,
    directReports: [],
    pendingDirectReports: [],
    focusPeople: [],
    otherPeople: [],
    focusPeopleRequests: [],
    pendingManagers: [],
    extendedDirectReports: [],
    invitedDirectReports: [],
    mrus: [],
    focusPeopleUserRelations: null,
    isManager: false,
    hasManagerialAccess: false,
    hasAzureRelation: false,
    allFocusPeopleSet: false
};
export var useRelationshipStore = create(//@ts-ignore
devtools(subscribeWithSelector(function(set, get) {
    return _object_spread_props(_object_spread({}, initialState), {
        setIsManager: function setIsManager(isManager) {
            set({
                isManager: isManager
            }, false, 'relationship/setIsManager');
        },
        setManager: function setManager(manager) {
            set({
                manager: manager
            }, false, 'relationship/setManager');
        },
        // Remove focus person
        removeFocusPerson: function removeFocusPerson(oid) {
            return _async_to_generator(function() {
                var state, allFocus, relatedUser, body, error, body1, error1, focusPeople, index, _state_manager, directReports;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            state = get();
                            allFocus = get().getAllFocus();
                            relatedUser = allFocus.find(function(fp) {
                                return fp.id === oid || fp.oid === oid;
                            });
                            if (!(relatedUser === null || relatedUser === void 0 ? void 0 : relatedUser.focusType)) return [
                                3,
                                5
                            ];
                            body = {
                                oid: oid,
                                focusType: relatedUser.focusType
                            };
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                axios.post('/api/common/removeFocusPerson', body)
                            ];
                        case 2:
                            _state.sent();
                            get().loadFocus();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.log('error ' + error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                3,
                                9
                            ];
                        case 5:
                            body1 = {
                                relatedUser: relatedUser
                            };
                            _state.label = 6;
                        case 6:
                            _state.trys.push([
                                6,
                                8,
                                ,
                                9
                            ]);
                            return [
                                4,
                                axios.post('/api/common/removeAzurePerson', body1)
                            ];
                        case 7:
                            _state.sent();
                            return [
                                3,
                                9
                            ];
                        case 8:
                            error1 = _state.sent();
                            console.log('error ' + error1);
                            return [
                                3,
                                9
                            ];
                        case 9:
                            // Update local state
                            focusPeople = _to_consumable_array(state.focusPeople);
                            index = focusPeople.findIndex(function(fp) {
                                return fp.id === oid || fp.oid === oid;
                            });
                            if (index > -1) {
                                focusPeople.splice(index, 1);
                                set({
                                    focusPeople: focusPeople
                                }, false, 'relationship/removeFocusPerson/focusPeople');
                            } else {
                                ;
                                directReports = _to_consumable_array(state.directReports);
                                index = directReports.findIndex(function(person) {
                                    return person.id === oid || person.oid === oid;
                                });
                                if (index > -1) {
                                    directReports.splice(index, 1);
                                    set({
                                        directReports: directReports
                                    }, false, 'relationship/removeFocusPerson/directReports');
                                } else if (oid === ((_state_manager = state.manager) === null || _state_manager === void 0 ? void 0 : _state_manager.oid)) {
                                    set({
                                        manager: null
                                    }, false, 'relationship/removeFocusPerson/manager');
                                }
                            }
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        // Load focus people from API
        loadFocus: function loadFocus() {
            var initial = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            return _async_to_generator(function() {
                var response, directReports, pendingDirectReports, manager, pendingManagers, focusPeople, otherPeople, invitedDirectReports, isManagerByDirectReports, hasManagerialAccess, extendedDirectReports, directReportKeys, indirectReports, allFocus, hasAzureRelation, focusPeopleUserRelations, error, _error_response_data, _error_response;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (initial) {
                                set({
                                    allFocusPeopleSet: false
                                }, false, 'relationship/loadFocus/start');
                            }
                            get().loadUserRelations();
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                axios.get('/api/common/getMyFocusPeople2')
                            ];
                        case 2:
                            response = _state.sent();
                            if (response.data) {
                                // Filter accepted and graph direct reports
                                directReports = response.data.directReports.filter(function(dr) {
                                    return dr.status ? dr.status === FOCUS_PEOPLE_STATUS.ACCEPTED : true;
                                });
                                // Filter pending direct reports
                                pendingDirectReports = response.data.directReports.filter(function(dr) {
                                    return dr.status ? dr.status === FOCUS_PEOPLE_STATUS.PENDING : false;
                                }).concat(response.data.pendingDirectReports || []);
                                // TODO Replace manager relationship with new User.manager identity
                                // TODO Also add User.virtualDirectReports as direct reports
                                manager = response.data.manager;
                                pendingManagers = response.data.myPendingManagers || [];
                                focusPeople = response.data.focusPeople || [];
                                otherPeople = response.data.otherPeople || [];
                                invitedDirectReports = response.data.invitedDirectReports || [];
                                isManagerByDirectReports = directReports && directReports.length > 0;
                                mixpanelSetUserProperty('Is Manager', isManagerByDirectReports);
                                window.Intercom('update', {
                                    'Is Manager': isManagerByDirectReports
                                });
                                hasManagerialAccess = focusPeople.some(function(fp) {
                                    return fp.isDirectRelation && fp.status === FOCUS_PEOPLE_STATUS.ACCEPTED;
                                });
                                // Build extended direct reports
                                extendedDirectReports = _to_consumable_array(directReports);
                                // A Teamflect-managed report (e.g. a non-Microsoft user) can be both a direct report and a
                                // direct-relation focus person — skip the ones already listed so pickers don't show them twice.
                                directReportKeys = new Set(directReports.flatMap(function(dr) {
                                    return [
                                        dr.oid || dr.id,
                                        dr.userPrincipalName
                                    ];
                                }).filter(Boolean));
                                indirectReports = focusPeople.filter(function(fp) {
                                    return fp.isDirectRelation && fp.status === FOCUS_PEOPLE_STATUS.ACCEPTED && !directReportKeys.has(fp.oid || fp.id) && !directReportKeys.has(fp.userPrincipalName);
                                });
                                if (indirectReports.length > 0) {
                                    extendedDirectReports = extendedDirectReports.concat(indirectReports);
                                }
                                // Check for Azure relations
                                allFocus = _to_consumable_array(directReports).concat(_to_consumable_array(focusPeople));
                                hasAzureRelation = allFocus.some(function(user) {
                                    return !('focusType' in user);
                                });
                                set({
                                    directReports: directReports,
                                    pendingDirectReports: pendingDirectReports,
                                    manager: manager,
                                    pendingManagers: pendingManagers,
                                    focusPeople: focusPeople,
                                    otherPeople: otherPeople,
                                    isManager: isManagerByDirectReports,
                                    hasManagerialAccess: hasManagerialAccess || get().hasManagerialAccess,
                                    extendedDirectReports: extendedDirectReports,
                                    invitedDirectReports: invitedDirectReports,
                                    hasAzureRelation: hasAzureRelation,
                                    allFocusPeopleSet: true
                                }, false, 'relationship/loadFocus/complete');
                                // Apply user relations if already loaded
                                focusPeopleUserRelations = get().focusPeopleUserRelations;
                                if (focusPeopleUserRelations) {
                                    get().setUserRelationsToFocusPeople();
                                }
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            if (((_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.code) === 'ErrorAccessDenied') {
                                useAuthStore.getState().updateAuthState({
                                    myPeopleErrorAccessDenied: true
                                });
                            }
                            // Any terminal failure must still complete the load, otherwise consumers keyed
                            // on allFocusPeopleSet (e.g. pages/MyTeam.tsx) spin forever.
                            set({
                                allFocusPeopleSet: true
                            }, false, 'relationship/loadFocus/failed');
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        // Load user relations
        loadUserRelations: function loadUserRelations() {
            axios.get('/api/common/getFocusPeopleUserRelations').then(function(response) {
                set({
                    focusPeopleUserRelations: response.data
                }, false, 'relationship/loadUserRelations');
                if (get().allFocusPeopleSet) {
                    get().setUserRelationsToFocusPeople();
                }
            }).catch(function() {});
        },
        // Get focus people requests
        getFocusPeopleRequests: function getFocusPeopleRequests() {
            axios.get('/api/common/getFocusPeopleRequests').then(function(res) {
                set({
                    focusPeopleRequests: res.data || []
                }, false, 'relationship/getFocusPeopleRequests');
            }).catch(function(err) {
                return console.log(err);
            });
        },
        // Load Most Recently Used contacts
        loadMrus: function loadMrus() {
            return _async_to_generator(function() {
                var _ref, data, returnedValues, filteredPersonas, e;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // MRU suggestions need a Graph capability external viewers don't have - the backend
                            // denies with 403 either way, so skip the doomed request entirely.
                            if (!getViewerCapabilities().peopleSuggestions) {
                                set({
                                    mrus: []
                                }, false, 'relationship/loadMrus/skipped');
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                axios.get('/api/common/getMRUs')
                            ];
                        case 2:
                            data = _state.sent().data;
                            returnedValues = data;
                            filteredPersonas = (_ref = returnedValues === null || returnedValues === void 0 ? void 0 : returnedValues.map(function(persona) {
                                return {
                                    id: persona.id,
                                    // Identity, not list position: PeoplePicker dedupes suggestions against the already
                                    // selected personas by key/UPN, so an index key made selected users reappear (AB#13158).
                                    key: persona.userPrincipalName,
                                    text: persona.displayName,
                                    department: persona.department,
                                    country: persona.country,
                                    birthday: persona.birthday,
                                    employeeHireDate: persona.employeeHireDate,
                                    officeLocation: persona.officeLocation,
                                    secondaryText: persona.jobTitle,
                                    userPrincipalName: persona.userPrincipalName,
                                    userRelation: {
                                        hasNotSignedUp: persona.hasNotSignedUp
                                    },
                                    mail: persona.userPrincipalName,
                                    displayName: persona.displayName,
                                    isNotAllowed: persona.isNotAllowed,
                                    hasNotSignedUp: persona.hasNotSignedUp
                                };
                            })) !== null && _ref !== void 0 ? _ref : [];
                            set({
                                mrus: filteredPersonas
                            }, false, 'relationship/loadMrus');
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            set({
                                mrus: []
                            }, false, 'relationship/loadMrus/failed');
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        // Computed: get all focus people combined
        getAllFocus: function getAllFocus() {
            var state = get();
            var allFocus = [];
            if (state.manager) {
                allFocus.push(state.manager);
            }
            if (state.directReports) {
                allFocus = allFocus.concat(state.directReports);
            }
            if (state.focusPeople) {
                allFocus = allFocus.concat(state.focusPeople);
            }
            if (state.pendingManagers) {
                allFocus = allFocus.concat(state.pendingManagers);
            }
            if (state.pendingDirectReports) {
                allFocus = allFocus.concat(state.pendingDirectReports);
            }
            return allFocus;
        },
        // Apply user relations to focus people
        setUserRelationsToFocusPeople: function setUserRelationsToFocusPeople() {
            var state = get();
            var focusPeopleUserRelations = state.focusPeopleUserRelations;
            if (!focusPeopleUserRelations) return;
            var drRelations = focusPeopleUserRelations.directReports, fpRelations = focusPeopleUserRelations.focusPeople, opRelations = focusPeopleUserRelations.otherPeople, pmRelations = focusPeopleUserRelations.pendingManagers, managerRelation = focusPeopleUserRelations.manager, pdrRelations = focusPeopleUserRelations.pendingDirectReports;
            var directReports = state.directReports.map(function(persona) {
                var dr = drRelations === null || drRelations === void 0 ? void 0 : drRelations.find(function(d) {
                    return d.oid === persona.oid || d.oid === persona.id;
                });
                return dr ? _object_spread_props(_object_spread({}, persona), {
                    userRelation: dr.userRelation
                }) : persona;
            });
            var pendingDirectReports = state.pendingDirectReports.map(function(persona) {
                var pdr = pdrRelations === null || pdrRelations === void 0 ? void 0 : pdrRelations.find(function(d) {
                    return d.oid === persona.oid || d.oid === persona.id;
                });
                return pdr ? _object_spread_props(_object_spread({}, persona), {
                    userRelation: pdr.userRelation
                }) : persona;
            });
            var focusPeople = state.focusPeople.map(function(persona) {
                var fp = fpRelations === null || fpRelations === void 0 ? void 0 : fpRelations.find(function(f) {
                    return f.oid === persona.oid || f.oid === persona.id;
                });
                return fp ? _object_spread_props(_object_spread({}, persona), {
                    userRelation: fp.userRelation
                }) : persona;
            });
            var extendedDirectReports = state.extendedDirectReports.map(function(persona) {
                var edr = fpRelations === null || fpRelations === void 0 ? void 0 : fpRelations.find(function(d) {
                    return d.oid === persona.oid || d.oid === persona.id;
                });
                return edr ? _object_spread_props(_object_spread({}, persona), {
                    userRelation: edr.userRelation
                }) : persona;
            });
            var otherPeople = state.otherPeople.map(function(persona) {
                var op = opRelations === null || opRelations === void 0 ? void 0 : opRelations.find(function(o) {
                    return o.oid === persona.oid || o.oid === persona.id;
                });
                return op ? _object_spread_props(_object_spread({}, persona), {
                    userRelation: op.userRelation
                }) : persona;
            });
            var pendingManagers = state.pendingManagers.map(function(persona) {
                var pm = pmRelations === null || pmRelations === void 0 ? void 0 : pmRelations.find(function(p) {
                    return p.oid === persona.oid || p.oid === persona.id;
                });
                return pm ? _object_spread_props(_object_spread({}, persona), {
                    userRelation: pm.userRelation
                }) : persona;
            });
            var manager = state.manager && managerRelation ? _object_spread_props(_object_spread({}, state.manager), {
                userRelation: managerRelation.userRelation
            }) : state.manager;
            set({
                directReports: directReports,
                pendingDirectReports: pendingDirectReports,
                focusPeople: focusPeople,
                extendedDirectReports: extendedDirectReports,
                otherPeople: otherPeople,
                pendingManagers: pendingManagers,
                manager: manager
            }, false, 'relationship/setUserRelationsToFocusPeople');
        },
        // Reset
        reset: function reset() {
            set(initialState, false, 'relationship/reset');
        }
    });
}), {
    name: 'RelationshipStore',
    enabled: process.env.NODE_ENV === 'development'
}));
/**
 * Initialize RelationshipStore from user data (called during login)
 */ export var initRelationshipFromUser = function initRelationshipFromUser(user) {
    var _user_manager;
    var store = useRelationshipStore.getState();
    // Set initial isManager from user data
    store.setIsManager(user.isManager || false);
    store.setManager((_user_manager = user.manager) === null || _user_manager === void 0 ? void 0 : _user_manager.identity);
    // Trigger async loading of relationships
    store.loadFocus(true);
    // Load MRUs (Most Recently Used contacts)
    store.loadMrus();
};
